import './App.css';
import React from 'react';
import { Helmet } from "react-helmet";
import Header from './Header';
import Footer from './Footer';
import HeroSlider from './HeroSlider';
import ServicesPage from './ServicesPage';
import ContactSection from './ContactSection';
import ContactSection2 from './ContactSection2';
import About from './About';
import Moving_with_a_lifting_crane from './Moving_with_a_lifting_crane';
import Crane_Rental from './Crane_Rental';
import Crane_work_throughout_the_country from './Crane_work_throughout_the_country';
import WorksGallery from './WorksGallery';
import Lifting_crane_in_Petah_Tikva from './Category/Lifting_crane_in_Petah_Tikva';
import Transportation_of_building_materials from './Category2/Transportation_of_building_materials';
import Transporting_wood from './Category2/Transporting_wood';
import Transporting_heavy_equipment from './Category2/Transporting_heavy_equipment';
import Container_Transportation from './Category2/Container_Transportation';
import Transportation_of_industrial_and_heavy_generators from './Category2/Transportation_of_industrial_and_heavy_generators';
import Basket_crane_rental from './Category3/Basket_crane_rental';
import Crane_Rental1 from './Category3/Crane_Rental1';
import Hourly_Lifting_Basket_Rental from './Category3/Hourly_Lifting_Basket_Rental';
import Renting_a_basket_crane_for_lifting_a_person from './Category3/Renting_a_basket_crane_for_lifting_a_person';
import Privacy_Policy from './Privacy_Policy/Privacy_Policy';
import Adsense from "./Adsense";       // 🔥 ייבוא באנר דף הבית (או באנר כללי)
import AccessibilityWidget from "./AccessibilityWidget";

import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation
} from 'react-router-dom';

import CookieConsent from './CookieConsent';
import WhatsAppBot from './WhatsAppBot';

import styled from "styled-components";

import NotFound from "./NotFound";


/* =========================================================
   ADS WRAPPER
========================================================= */

const AdsWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  min-height: 0 !important;
  height: auto !important;
  overflow: hidden;

  ins.adsbygoogle {
    display: block !important;
    margin: 0 !important;
    padding: 0 !important;
    height: auto !important;
    line-height: 0;
  }
`;


/* =========================================================
   SEO DATA
========================================================= */

const seoPages = {

  "/": {
    title:
      "ש.מ הובלות ומנופים | הובלות עם מנוף, מנופים ושירותי הרמה",

    description:
      "ש.מ הובלות ומנופים מספקים שירותי הובלה, הובלות עם מנוף, שירותי מנוף, הרמות ושינוע ציוד כבד. שירות מקצועי ואמין ללקוחות פרטיים, עסקיים וקבלנים.",

    keywords:
      "ש.מ הובלות ומנופים, הובלות, חברת הובלות, הובלות עם מנוף, מנוף להובלה, שירותי מנוף, הרמות, שינוע, הובלת ציוד כבד, הובלות לעסקים, הובלות לקבלנים, מנופים",

    image:
      "https://smtovala.co.il/logo193.png"
  },


  "/ServicesPage": {
    title:
      "שירותי הובלה ומנופים | ש.מ הובלות ומנופים",

    description:
      "כל שירותי ש.מ הובלות ומנופים במקום אחד: הובלות עם מנוף, מנופי סל, מנוף זרוע, הובלת חומרי בניין, ציוד כבד, מכולות ועוד.",

    keywords:
      "שירותי הובלה, שירותי מנוף, הובלות עם מנוף, מנוף סל, מנוף זרוע, הובלת ציוד כבד, הובלת חומרי בניין, ש.מ הובלות ומנופים",

    image:
      "https://smtovala.co.il/logo193.png"
  },


  "/About": {
    title:
      "אודות ש.מ הובלות ומנופים | חברת הובלות ומנופים",

    description:
      "הכירו את ש.מ הובלות ומנופים – חברה המספקת שירותי הובלה, מנופים, הרמות ושינוע ציוד ללקוחות פרטיים, עסקים וקבלנים.",

    keywords:
      "אודות ש.מ הובלות ומנופים, חברת הובלות, חברת מנופים, הובלות מקצועיות, שירותי הרמה, שינוע ציוד",

    image:
      "https://smtovala.co.il/logo193.png"
  },


  "/Moving_with_a_lifting_crane": {
    title:
      "הובלות עם מנוף הרמה | ש.מ הובלות ומנופים",

    description:
      "הובלות עם מנוף הרמה לציוד, חומרי בניין ופריטים גדולים. שירות מקצועי לבתים, עסקים, אתרי בנייה וקבלנים, כולל במקומות עם גישה מורכבת.",

    keywords:
      "הובלות עם מנוף, הובלה עם מנוף הרמה, מנוף הרמה, הובלת ציוד עם מנוף, הובלות לקבלנים, ש.מ הובלות ומנופים",

    image:
      "https://smtovala.co.il/logo193.png"
  },


  "/Crane_Rental": {
    title:
      "השכרת מנופים | מנוף סל ומנוף זרוע | ש.מ הובלות ומנופים",

    description:
      "השכרת מנופים לעבודות הרמה והובלה: מנוף סל, מנוף זרוע וסלי הרמה. שירות מקצועי וגמיש לעבודות פרטיות, עסקיות וקבלניות.",

    keywords:
      "השכרת מנוף, השכרת מנופים, מנוף סל להשכרה, מנוף זרוע להשכרה, סל הרמה, שירותי מנוף",

    image:
      "https://smtovala.co.il/logo193.png"
  },


  "/Crane_work_throughout_the_country": {
    title:
      "עבודות מנוף בכל הארץ | ש.מ הובלות ומנופים",

    description:
      "שירותי הובלה, מנוף והרמה בפריסה רחבה ברחבי הארץ. פתרונות מנוף לעבודות הרמה, הובלת ציוד, שינוע ומטענים בגדלים שונים.",

    keywords:
      "עבודות מנוף בכל הארץ, שירותי מנוף, מנוף להובלה, עבודות הרמה, הובלות עם מנוף, ש.מ הובלות ומנופים",

    image:
      "https://smtovala.co.il/logo193.png"
  },


  "/WorksGallery": {
    title:
      "גלריית עבודות | ש.מ הובלות ומנופים",

    description:
      "גלריית עבודות של ש.מ הובלות ומנופים – הובלות, עבודות מנוף, הרמות ושינוע ציוד שבוצעו עבור לקוחות פרטיים, עסקים וקבלנים.",

    keywords:
      "גלריית עבודות מנוף, עבודות הובלה, עבודות מנוף, ש.מ הובלות ומנופים, הרמות עם מנוף",

    image:
      "https://smtovala.co.il/logo193.png"
  },


  "/Lifting_crane_in_Tel_Aviv": {
    title:
      "מנוף הרמה בתל אביב | שירותי מנוף בתל אביב | ש.מ",

    description:
      "שירותי מנוף והרמה בתל אביב לעבודות בגובה, הובלת ציוד והרמת מטענים. פתרונות גם לרחובות צרים, שטחים צפופים ואתרים עם גישה מורכבת.",

    keywords:
      "מנוף הרמה בתל אביב, מנוף בתל אביב, שירותי מנוף תל אביב, הובלה עם מנוף תל אביב, מנוף הרמה",

    image:
      "https://smtovala.co.il/logo193.png"
  },


  "/Transportation_of_building_materials": {
    title:
      "הובלת חומרי בניין | הובלות לקבלנים | ש.מ הובלות ומנופים",

    description:
      "הובלת חומרי בניין לאתרי בנייה, קבלנים ולקוחות פרטיים. שירותי הובלה מקצועיים עם התאמה לתנאי השטח וביצוע בטוח ומדויק.",

    keywords:
      "הובלת חומרי בניין, הובלות חומרי בניין, הובלה לקבלנים, הובלת ציוד לאתרי בנייה, ש.מ הובלות ומנופים",

    image:
      "https://smtovala.co.il/logo193.png"
  },


  "/Transporting_wood": {
    title:
      "הובלת עצים | שינוע עצים והובלות | ש.מ הובלות ומנופים",

    description:
      "שירותי הובלת עצים ושינוע מטעני עץ ללקוחות פרטיים, עסקים וקבלנים, עם התאמת הרכב ואמצעי ההובלה לסוג ולכמות המטען.",

    keywords:
      "הובלת עצים, שינוע עצים, הובלת מטען עץ, הובלות לקבלנים, ש.מ הובלות ומנופים",

    image:
      "https://smtovala.co.il/logo193.png"
  },


  "/Transporting_heavy_equipment": {
    title:
      "הובלת ציוד כבד | שינוע ציוד כבד | ש.מ הובלות ומנופים",

    description:
      "הובלת ציוד כבד, מכונות וציוד תעשייתי בהתאמה למשקל, למידות ולתנאי הגישה. שירות מקצועי ללקוחות עסקיים, תעשייה וקבלנים.",

    keywords:
      "הובלת ציוד כבד, שינוע ציוד כבד, הובלת מכונות, הובלת ציוד תעשייתי, הובלות כבדות, ש.מ הובלות ומנופים",

    image:
      "https://smtovala.co.il/logo193.png"
  },


  "/Container_Transportation": {
    title:
      "הובלת מכולות | הובלת קונטיינרים | ש.מ הובלות ומנופים",

    description:
      "שירותי הובלת מכולות וקונטיינרים עם פתרונות שינוע והובלה המותאמים לתנאי השטח. שירות לעסקים, קבלנים ולקוחות פרטיים.",

    keywords:
      "הובלת מכולות, הובלת קונטיינרים, הובלת מכולה, שינוע מכולות, הובלות לעסקים, ש.מ הובלות ומנופים",

    image:
      "https://smtovala.co.il/logo193.png"
  },


  "/Transportation_of_industrial_and_heavy_generators": {
    title:
      "הובלת גנרטורים תעשייתיים | גנרטורים כבדים | ש.מ הובלות",

    description:
      "הובלת גנרטורים תעשייתיים וכבדים באמצעות פתרונות הובלה ושינוע המותאמים למשקל, למידות ולתנאי השטח.",

    keywords:
      "הובלת גנרטורים, הובלת גנרטור תעשייתי, הובלת גנרטורים כבדים, שינוע גנרטורים, ש.מ הובלות ומנופים",

    image:
      "https://smtovala.co.il/logo193.png"
  },


  "/Basket_crane_rental": {
    title:
      "השכרת מנוף סל | מנוף סל להשכרה | ש.מ הובלות ומנופים",

    description:
      "השכרת מנוף סל לעבודות הרמה בגובה, תחזוקה, התקנות ועבודות שונות. התאמת המנוף לתנאי השטח ולדרישות העבודה.",

    keywords:
      "השכרת מנוף סל, מנוף סל להשכרה, מנוף סל, השכרת מנוף, עבודות בגובה, ש.מ הובלות ומנופים",

    image:
      "https://smtovala.co.il/logo193.png"
  },


  "/Crane_Rental1": {
    title:
      "השכרת מנוף זרוע | מנוף זרוע להשכרה | ש.מ הובלות ומנופים",

    description:
      "השכרת מנוף זרוע לעבודות הרמה, הובלה ושינוע ציוד. פתרונות מנוף מקצועיים לעסקים, קבלנים ולקוחות פרטיים.",

    keywords:
      "השכרת מנוף זרוע, מנוף זרוע להשכרה, מנוף זרוע, השכרת מנופים, שירותי מנוף",

    image:
      "https://smtovala.co.il/logo193.png"
  },


  "/Hourly_Lifting_Basket_Rental": {
    title:
      "השכרת סל הרמה לפי שעה | סל הרמה | ש.מ הובלות ומנופים",

    description:
      "השכרת סל הרמה לפי שעה לעבודות בגובה, תחזוקה, התקנות ועבודות מקצועיות. שירות גמיש בהתאם לצורכי העבודה ולתנאי השטח.",

    keywords:
      "השכרת סל הרמה לפי שעה, סל הרמה, השכרת סל הרמה, מנוף סל, עבודות בגובה",

    image:
      "https://smtovala.co.il/logo193.png"
  },


  "/Renting_a_basket_crane_for_lifting_a_person": {
    title:
      "מנוף סל להרמת אדם | השכרת מנוף סל לאדם | ש.מ",

    description:
      "השכרת מנוף סל להרמת אדם לעבודות בגובה, תחזוקה, התקנות וגיזום. שירות מקצועי עם התאמת המנוף לתנאי השטח ולדרישות העבודה.",

    keywords:
      "מנוף סל להרמת אדם, השכרת מנוף סל לאדם, מנוף להרמת אדם, עבודות בגובה, סל הרמה",

    image:
      "https://smtovala.co.il/logo193.png"
  },


  "/ContactSection2": {
    title:
      "צור קשר | ש.מ הובלות ומנופים",

    description:
      "צרו קשר עם ש.מ הובלות ומנופים לקבלת הצעת מחיר ושירותי הובלה, מנוף, הרמה ושינוע. מענה ללקוחות פרטיים, עסקים וקבלנים.",

    keywords:
      "צור קשר ש.מ הובלות ומנופים, הצעת מחיר הובלות, הצעת מחיר מנוף, שירותי הובלה, שירותי מנוף",

    image:
      "https://smtovala.co.il/logo193.png"
  },


  "/ContactSection": {
    title:
      "יצירת קשר | ש.מ הובלות ומנופים",

    description:
      "פנו אל ש.מ הובלות ומנופים לקבלת פרטים, הצעת מחיר ותיאום שירותי הובלה, מנוף, הרמה ושינוע.",

    keywords:
      "יצירת קשר הובלות, ש.מ הובלות ומנופים, שירותי מנוף, הצעת מחיר הובלה",

    image:
      "https://smtovala.co.il/logo193.png"
  },


  "/Privacy_Policy": {
    title:
      "מדיניות פרטיות | ש.מ הובלות ומנופים",

    description:
      "מדיניות הפרטיות של אתר ש.מ הובלות ומנופים והמידע הנוגע לשימוש באתר ולפרטיות המשתמשים.",

    keywords:
      "מדיניות פרטיות, ש.מ הובלות ומנופים, פרטיות באתר",

    image:
      "https://smtovala.co.il/logo193.png"
  }

};


/* =========================================================
   SEO COMPONENT
========================================================= */

function SEO() {

  const location = useLocation();

  const currentSEO =
    seoPages[location.pathname] || {
      title:
        "ש.מ הובלות ומנופים | הובלות ומנופים",

      description:
        "ש.מ הובלות ומנופים – שירותי הובלה, מנופים, הרמות ושינוע ציוד ללקוחות פרטיים, עסקים וקבלנים.",

      keywords:
        "ש.מ הובלות ומנופים, הובלות, מנופים, שירותי הרמה, שינוע",

      image:
        "https://smtovala.co.il/logo193.png"
    };


  const canonicalURL =
    `https://smtovala.co.il${location.pathname === "/" ? "/" : location.pathname}`;


  return (

    <Helmet>

      {/* =========================
          BASIC SEO
      ========================= */}

      <html lang="he" />

      <title>
        {currentSEO.title}
      </title>

      <meta
        name="description"
        content={currentSEO.description}
      />

      <meta
        name="keywords"
        content={currentSEO.keywords}
      />

      <meta
        name="robots"
        content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
      />


      {/* =========================
          CANONICAL
      ========================= */}

      <link
        rel="canonical"
        href={canonicalURL}
      />


      {/* =========================
          OPEN GRAPH
      ========================= */}

      <meta
        property="og:type"
        content="website"
      />

      <meta
        property="og:title"
        content={currentSEO.title}
      />

      <meta
        property="og:description"
        content={currentSEO.description}
      />

      <meta
        property="og:url"
        content={canonicalURL}
      />

      <meta
        property="og:image"
        content={currentSEO.image}
      />

      <meta
        property="og:site_name"
        content="ש.מ הובלות ומנופים"
      />

      <meta
        property="og:locale"
        content="he_IL"
      />


      {/* =========================
          TWITTER / X
      ========================= */}

      <meta
        name="twitter:card"
        content="summary_large_image"
      />

      <meta
        name="twitter:title"
        content={currentSEO.title}
      />

      <meta
        name="twitter:description"
        content={currentSEO.description}
      />

      <meta
        name="twitter:image"
        content={currentSEO.image}
      />


      {/* =========================
          BUSINESS INFORMATION
      ========================= */}

      <meta
        name="author"
        content="ש.מ הובלות ומנופים"
      />

      <meta
        name="geo.region"
        content="IL"
      />

      <meta
        name="geo.placename"
        content="פתח תקווה"
      />

    </Helmet>
  );
}


/* =========================================================
   APP
========================================================= */

function App() {

  return (

    <React.Fragment>

      <Router>

        {/* SEO משתנה אוטומטית לפי הדף */}
        <SEO />

            <AccessibilityWidget />
  <div id="site-content">

        <Header />


        <CookieConsent />


        <WhatsAppBot />




        <Switch>

          <Route
            exact
            path="/"
            component={HeroSlider}
          />

          <Route
            exact
            path="/ServicesPage"
            component={ServicesPage}
          />

          <Route
            exact
            path="/ContactSection2"
            component={ContactSection2}
          />

          <Route
            exact
            path="/ContactSection"
            component={ContactSection}
          />

          <Route
            exact
            path="/About"
            component={About}
          />

          <Route
            exact
            path="/Moving_with_a_lifting_crane"
            component={Moving_with_a_lifting_crane}
          />

          <Route
            exact
            path="/Crane_Rental"
            component={Crane_Rental}
          />

          <Route
            exact
            path="/Crane_work_throughout_the_country"
            component={Crane_work_throughout_the_country}
          />

          <Route
            exact
            path="/WorksGallery"
            component={WorksGallery}
          />

          <Route
            exact
            path="/Lifting_crane_in_Petah_Tikva"
            component={Lifting_crane_in_Petah_Tikva}
          />

          <Route
            exact
            path="/Transportation_of_building_materials"
            component={Transportation_of_building_materials}
          />

          <Route
            exact
            path="/Transporting_wood"
            component={Transporting_wood}
          />

          <Route
            exact
            path="/Transporting_heavy_equipment"
            component={Transporting_heavy_equipment}
          />

          <Route
            exact
            path="/Container_Transportation"
            component={Container_Transportation}
          />

          <Route
            exact
            path="/Transportation_of_industrial_and_heavy_generators"
            component={Transportation_of_industrial_and_heavy_generators}
          />

          <Route
            exact
            path="/Basket_crane_rental"
            component={Basket_crane_rental}
          />

          <Route
            exact
            path="/Crane_Rental1"
            component={Crane_Rental1}
          />

          <Route
            exact
            path="/Hourly_Lifting_Basket_Rental"
            component={Hourly_Lifting_Basket_Rental}
          />

          <Route
            exact
            path="/Renting_a_basket_crane_for_lifting_a_person"
            component={Renting_a_basket_crane_for_lifting_a_person}
          />

          <Route
            exact
            path="/Privacy_Policy"
            component={Privacy_Policy}
          />

          <Route
            component={NotFound}
          />

        </Switch>


        <Footer />
<Adsense />
</div>

      </Router>

    </React.Fragment>

  );
}


export default App;
